import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { Navigate } from "react-router-dom";
import { useContentfulEntry } from '../../hooks/useContentfulEntry';

/**
 * LegacyUrlSuggestion
 * Props:
 * - section: Contentful section object (with headline, description, etc.)
 * - entryId: Contentful entry ID for the legacy article (string)
 */
function LegacyUrlSuggestion({ section, entryId }) {
  const { entry, loading, error } = useContentfulEntry(entryId);

  if (loading || error || !entry) return null;

  if (entry.fields.automaticallyRedirect && entry.fields.article?.fields?.url) {
    return (
      <Navigate to={entry.fields.article.fields.url} replace />
    );
  }

  return (
    <Container fluid>
      <Row>
        <Col lg={12} md={12}>
          <div id="old-website-link">
            <div className='tagline'>{section.fields.headline}</div>
            <p>{section.fields.description}</p>
            {entry.fields.article?.fields?.url && (
              <a href={entry.fields.article.fields.url}>
                <span className="fa-stack fa-2x" style={{ verticalAlign: 'bottom', marginLeft: 10, marginRight: 10 }}>
                  <i className="fas fa-circle fa-stack-2x"></i>
                  <i className="fas fa-arrow-right fa-stack-1x fa-inverse"></i>
                </span>
                {entry.fields.article.fields.heading}
              </a>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default LegacyUrlSuggestion;
